<script>
import Layout from '@layouts/login'
import { authMethods } from '@state/helpers'
import appConfig from '@src/app.config'

export default {
  metaInfo: {
    title: 'Log in',
    meta: [{ name: 'description', content: `Log in to ${appConfig.title}` }],
  },
  components: { Layout },
  data() {
    return {
      valid: true,
      username: '',
      password: '',
      authError: null,
      tryingToLogIn: false,
    }
  },
  computed: {
    usernameError() {
      const error = this.$i18n.t('validation__username_required')
      return error
    },
    usernameRules() {
      return [value => !!value || this.$i18n.t('validation__username_required')]
    },
    passwordRules() {
      return [value => !!value || this.$i18n.t('validation__password_required')]
    },
    locale() {
      return this.$i18n.locale
    },
  },
  watch: {
    locale() {
      this.$refs.loginForm.reset()
    },
  },
  methods: {
    ...authMethods,
    tryToLogIn() {
      if (!this.$refs.loginForm.validate()) {
        this.valid = false
        return
      }
      this.tryingToLogIn = true
      this.authError = null
      return this.logIn({
        username: this.username,
        password: this.password,
      })
        .then(() => {
          this.$router.push({ name: 'home' })
          this.tryingToLogIn = false
        })
        .catch(error => {
          switch (error.response.status) {
            case 500:
              this.authError = 'login_failed'
              break
            case 401:
              if (
                error.response.data.error_description === 'message_blocked_user'
              ) {
                this.authError = 'unauthorized'
              } else {
                this.authError = 'invalid_grant'
              }
              break
            default:
              this.authError = 'invalid_grant'
              break
          }
          this.tryingToLogIn = false
        })
    },
  },
}
</script>

<template>
  <Layout>
    <v-form
      ref="loginForm"
      v-model="valid"
      lazy-validation
      @submit.prevent="tryToLogIn"
    >
      <v-text-field
        :rules="usernameRules"
        v-model="username"
        :label="$t('label__username')"
        required
      />
      <v-text-field
        :rules="passwordRules"
        v-model="password"
        :label="$t('label__password')"
        type="password"
        required
      />
      <v-btn
        :loading="tryingToLogIn"
        :disabled="tryingToLogIn"
        color="primary"
        block
        type="submit"
      >
        {{ $t('buttons__login') }}
      </v-btn>
      <router-link
        :to="{name: 'forgotPassword'}">Forgot password</router-link>
    </v-form>
    <div :class="$style.errorBlock">
      <span
        v-if="authError"
        :class="$style.errorText"
      >
        {{ $t(`error__${authError}`) }}
      </span>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
.error {
  &Block {
    height: 50px;
    text-align: center;
  }

  &Text {
    font-size: 13px;
    color: $error;
  }
}
</style>
